import { createCommand } from 'lexical';
export const INSERT_FILE_COMMAND = createCommand('INSERT_FILE_COMMAND');
export const UPLOAD_AND_INSERT_FILE_COMMAND = createCommand('UPLOAD_AND_INSERT_FILE_COMMAND');
export const INSERT_BUBBLE_COMMAND = createCommand('INSERT_BUBBLE_COMMAND');
export const INSERT_DATETIME_COMMAND = createCommand('INSERT_DATETIME_COMMAND');
export const INSERT_PASSWORD_COMMAND = createCommand('INSERT_PASSWORD_COMMAND');
export const INSERT_REMOTE_IMAGE_COMMAND = createCommand('INSERT_REMOTE_IMAGE_COMMAND');
